import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { matchPath, Navigate } from "react-router-dom";

const HIDE_PADDING_ROUTES: string[] = ["/disputes", "/disputes/*"];

function hidePadding(url: string): boolean {
  return HIDE_PADDING_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/finance${route}`, url),
  );
}

export const financeRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Finance" },
    async lazy() {
      const { Page } = await import("../../page");
      return { element: <Page hidePadding={hidePadding} /> };
    },
    children: [
      { index: true, element: <Navigate replace to="disputes" /> },
      {
        path: "disputes",
        handle: { breadcrumb: "Disputes" },
        children: [
          {
            index: true,
            async lazy() {
              const { DisputesPage } = await import(
                "../../../finance/disputes/disputes-page"
              );
              return { Component: DisputesPage };
            },
          },
          {
            path: ":disputeId",
            handle: { breadcrumb: "Dispute Detail" },
            async lazy() {
              const { DisputeDetailPage } = await import(
                "../../../finance/disputes/dispute-detail-page"
              );
              return { Component: DisputeDetailPage };
            },
          },
        ],
      },
    ],
  },
];
